(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-lp-confidence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MAX = 989;

    function initConfidence(root) {
      if (!root || root.dataset.mmLpConfidenceInit === 'true') return;
      var track = root.querySelector('[data-mm-lp-confidence-track]');
      if (!track) return;

      root.dataset.mmLpConfidenceInit = 'true';

      var prev = root.querySelector('[data-mm-lp-confidence-prev]');
      var next = root.querySelector('[data-mm-lp-confidence-next]');
      var dots = root.querySelectorAll('[data-mm-lp-confidence-dot]');
      var slides = track.querySelectorAll('[data-mm-lp-confidence-slide]');

      function isMobile() {
        return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
      }

      function activeIndex() {
        if (!slides.length) return 0;
        var trackLeft = track.getBoundingClientRect().left;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('mm-lp-confidence__dot--active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function scrollToIndex(index) {
        var slide = slides[index];
        if (!slide || !isMobile()) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function onScroll() {
        if (!isMobile()) return;
        setActiveDot(activeIndex());
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i < slides.length - 1 ? i + 1 : 0);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(index)) scrollToIndex(index);
        });
      });

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    function boot() {
      document.querySelectorAll('[data-mm-lp-confidence]').forEach(initConfidence);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-mm-lp-confidence]');
      if (root) {
        delete root.dataset.mmLpConfidenceInit;
        initConfidence(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-lp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-mm-lp-faq]');
    sections.forEach(function (root) {
      var items = root.querySelectorAll('[data-mm-lp-faq-item]');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-lp-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MAX = 989;

    function initFeatureShowcase(root) {
      if (!root || root.dataset.mmLpFeatureShowcaseInit === 'true') return;
      var track = root.querySelector('[data-mm-lp-feature-showcase-track]');
      if (!track) return;

      root.dataset.mmLpFeatureShowcaseInit = 'true';

      var prev = root.querySelector('[data-mm-lp-feature-showcase-prev]');
      var next = root.querySelector('[data-mm-lp-feature-showcase-next]');
      var dots = root.querySelectorAll('[data-mm-lp-feature-showcase-dot]');
      var slides = track.querySelectorAll('[data-mm-lp-feature-showcase-slide]');

      function isMobile() {
        return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
      }

      function activeIndex() {
        if (!slides.length) return 0;
        var trackLeft = track.getBoundingClientRect().left;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('mm-lp-feature-showcase__dot--active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function scrollToIndex(index) {
        var slide = slides[index];
        if (!slide || !isMobile()) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function onScroll() {
        if (!isMobile()) return;
        setActiveDot(activeIndex());
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i < slides.length - 1 ? i + 1 : 0);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(index)) scrollToIndex(index);
        });
      });

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    function boot() {
      document.querySelectorAll('[data-mm-lp-feature-showcase]').forEach(initFeatureShowcase);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-mm-lp-feature-showcase]');
      if (root) {
        delete root.dataset.mmLpFeatureShowcaseInit;
        initFeatureShowcase(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-lp-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var MOBILE_MAX = 989;

    function initTestimonials(root) {
      if (!root || root.dataset.mmLpTestimonialsInit === 'true') return;
      var track = root.querySelector('[data-mm-lp-testimonials-track]');
      if (!track) return;

      root.dataset.mmLpTestimonialsInit = 'true';

      var prev = root.querySelector('[data-mm-lp-testimonials-prev]');
      var next = root.querySelector('[data-mm-lp-testimonials-next]');
      var dots = root.querySelectorAll('[data-mm-lp-testimonials-dot]');
      var slides = track.querySelectorAll('[data-mm-lp-testimonials-slide]');

      function isMobile() {
        return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
      }

      function activeIndex() {
        if (!slides.length) return 0;
        var trackLeft = track.getBoundingClientRect().left;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('mm-lp-testimonials__dot--active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      function scrollToIndex(index) {
        var slide = slides[index];
        if (!slide || !isMobile()) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function onScroll() {
        if (!isMobile()) return;
        setActiveDot(activeIndex());
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          if (!isMobile()) return;
          var i = activeIndex();
          scrollToIndex(i < slides.length - 1 ? i + 1 : 0);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          if (!isNaN(index)) scrollToIndex(index);
        });
      });

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    function boot() {
      document.querySelectorAll('[data-mm-lp-testimonials]').forEach(initTestimonials);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-mm-lp-testimonials]');
      if (root) {
        delete root.dataset.mmLpTestimonialsInit;
        initTestimonials(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
